"use client"

import { ArrowDownNarrowWide } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ArrowDownNarrowWideIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ArrowDownNarrowWideIcon = component(Icon)({
  as: ArrowDownNarrowWide,
})
